<app-metadata [graphName]="'reg-health-workers'"></app-metadata>
<button mat-raised-button color="primary" (click)="addNewHealthData()"
  i18n="add new district@@add_district">
  Add new district or national level data
</button>
@for (district of districts; track district) {
  <app-form
    [helptexts]="helptexts[0]"
    [data]="district"
    [showDelete]="true"
    (deleted)="deleteHealthData($event)"
    [informations]="informations"
    (dataSubmitted)="onData($event)"
    >
  </app-form>
}
